import React, { useState } from "react";

type InputBoxProps = {
  placeholder?: string;
  onSubmit: (value: string) => void;
  invisible?: boolean;
};

export const InputBox = ({ placeholder = "Start typing what you hear…", onSubmit, invisible=false }: InputBoxProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim()) {
      onSubmit(inputValue);
      setInputValue(""); // Clear the input box after submission
    }
  };

  return (
    <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyPress}
        placeholder={placeholder}
        className={`border p-2 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${invisible ? 'hidden' : ''}`}
    />
  );
};
export default InputBox